import { TIIndicatorPointToHighChartIndicatorPointMapper } from "../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { IndicatorOptionModel } from "../models/drop-down-list/indicator-option.model";

export class TIIndicatorDataToDCSeriesBuilder {
    public static map(indicator: IndicatorOptionModel, rawIndicatorData: TIIndicatorDataModel, indicatorConfig: any, mainYAxis: string): Array<any> {
        if (!indicatorConfig || !indicatorConfig.series) {
            return [];
        }
        
        let result: Array<any> = [];

        const dcTopSerie: any = indicatorConfig.series[0];
        const dcBottomSerie: any = indicatorConfig.series[1];

        const dcTopNeedZone = rawIndicatorData.needHighChartZone(dcTopSerie.type);
        const builtDcTopSerieDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawIndicatorData, indicator.value, true);
        
        dcTopSerie.name = rawIndicatorData.name;
        dcTopSerie.data = builtDcTopSerieDataPoints.points;
        dcTopSerie.className = 'indicator-series ' + rawIndicatorData.getClassName();

        if (dcTopNeedZone) {
            dcTopSerie.zones = builtDcTopSerieDataPoints.zones;
            rawIndicatorData.zones = builtDcTopSerieDataPoints.zones;
            dcTopSerie.zoneAxis = 'x';
        }

        dcTopSerie.yAxis = rawIndicatorData.chartAreaName + '-y-axis';

        dcTopSerie.lastPrice = {
            enabled: mainYAxis != dcTopSerie.yAxis,
            className: 'last-price-indicator-' + indicator.getClassName(),
            // color: 'rgba(0, 0, 0, 0)'
        };

        result.push(dcTopSerie);

        if (rawIndicatorData.childIndicators?.length > 0) {
            const dcBottoms = rawIndicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('DC B') >= 0);
            if (dcBottoms) {
                const dcBottomNeedZone = dcBottoms.needHighChartZone(dcBottomSerie.type);
                const builtDcBottomsDataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(dcBottoms, indicator.value, true);
                dcBottomSerie.name = dcBottoms.name;
                dcBottomSerie.data = builtDcBottomsDataPoints.points;
                dcBottomSerie.className = 'indicator-series ' + dcBottoms.getClassName();

                if (dcBottomNeedZone) {
                    dcBottomSerie.zones = builtDcBottomsDataPoints.zones;
                    dcBottoms.zones = builtDcBottomsDataPoints.zones;
                    dcBottomSerie.zoneAxis = 'x';
                }

                dcBottomSerie.yAxis = rawIndicatorData.chartAreaName + '-y-axis';
                
                result.push(dcBottomSerie);
            }
        }

        return result;
    }
}
